module.exports = __webpack_public_path__ + "img/ancient_bear_small.f571e21b.png";